<template>
  <div>
    <el-row style="margin-top:10px">
      <el-col :span="22">
        <el-form ref="searchForm" v-model="searchForm" :inline="true" label-suffix="：" size="medium">
          <el-form-item label="客户名称">
            <el-select v-model="searchForm.TC_ID" placeholder="请选择" filterable clearable>
              <el-option v-for="item in customerList" :key="item.TC_ID" :label="item.AB_NAME" :value="item.TC_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名称">
            <el-input v-model="searchForm.PRODUCT_NAME" @keyup.enter.native="conditionalSearch" placeholder="请输入" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="商品编码">
            <el-input v-model="searchForm.PRODUCT_CODE" @keyup.enter.native="conditionalSearch" placeholder="请输入">
            </el-input>
          </el-form-item>
          <el-form-item label="差异类型">
            <el-select v-model="searchForm.TYPE" placeholder="请选择" @change="conditionalSearch" clearable>
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left:20px" @click="conditionalSearch" :loading="loading">筛选</el-button>
            <el-button type="primary" plain style="margin-left:20px" @click="exportData" :loading="loading">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户名称" min-width="250"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码" width="170"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="200"></el-table-column>
          <el-table-column prop="MODE" label="差异类型" min-width="80"></el-table-column>
          <el-table-column label="客户价格">
            <el-table-column prop="CURRENT_PRICE" label="当期价格" width="120"></el-table-column>
            <el-table-column prop="NEXT_PRICE" label="下期价格" width="120"></el-table-column>
            <el-table-column prop="NEXT_EFFECTIVE_DATE" label="下期生效日期" width="110"></el-table-column>
            <el-table-column prop="UPDATE_TIME" label="更新日期" width="100"></el-table-column>
          </el-table-column>
          <el-table-column label="己方价格">
            <el-table-column prop="PRICE" label="价格" width="120"></el-table-column>
            <el-table-column prop="START_DAY" label="开始日期" width="100"></el-table-column>
            <el-table-column prop="END_DAY" label="结束日期" width="100"></el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="height:100px">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalNum" style="float: right; height: 100px;">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      filterData: [],
      loading: false,
      searchForm: {},
      customerList: JSON.parse(sessionStorage.getItem('allCustomerList')) || [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      typeList: [
        { id: 'current', name: '当前价格', MODE: '当期价格不一致' },
        { id: 'next', name: '下期价格', MODE: '下期价格不一致' },
        { id: 'lack', name: '缺少价格', MODE: '缺少周期价格' }],
      type: '',
      allData: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.SAVE_DSORDER_LIST) {
    //   this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
    //   this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    // } else {
    //   this.currentPage = 1;
    // }
  },
  mounted() {
    this.defaultQuery();
  },
  methods: {
    defaultQuery() {
      this.loading = true;
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 38,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TYPE: this.searchForm.TYPE || 'all',
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        if (params.TYPE == 'all') {
          this.tableData = result.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
          this.totalNum = result.length;
          this.allData = result;
          this.filterData = [...result];
        } else {
          this.tableData = result.PRODUCT_LIST;
          this.totalNum = result.TOTAL_COUNT;
        }
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    // handleSearch() {
    //   this.currentPage = 1;
    //   this.defaultQuery();
    // },
    conditionalSearch() {
      this.currentPage = 1;
      this.filterData = this.allData.filter(({
        TC_ID, PRODUCT_CODE, PRODUCT_NAME, MODE,
      }) => (
        this.searchForm.TC_ID ? TC_ID == this.searchForm.TC_ID : true
      )
          && (
            this.searchForm.PRODUCT_CODE ? PRODUCT_CODE == this.searchForm.PRODUCT_CODE : true
          )
          && (
            this.searchForm.PRODUCT_NAME ? PRODUCT_NAME.includes(this.searchForm.PRODUCT_NAME) : true
          )
          && (
            this.searchForm.TYPE ? MODE == this.typeList.find(({ id }) => id == this.searchForm.TYPE).MODE : true
          ));
      this.tableData = this.filterData.slice(0, this.pageSize);
      this.totalNum = this.filterData.length;
    },
    handleCurrentChange(e) {
      const startIndex = (e - 1) * this.pageSize; // 计算起始索引
      const endIndex = startIndex + this.pageSize; // 计算结束索引
      this.tableData = this.filterData.slice(startIndex, endIndex);
    },
    exportData() {
      this.loading = true;
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 39,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result.FILE_PATH);
        this.$message.show({ text: '导出成功', type: 'success' });
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/customerPricingDifferenceQuery.vue